import { circlePath, ellipsePath, starPath, heartPath, groundPath } from "./artHelpers";

export const FREE_PAGES = [
  {
    id: "pumpkin-pal",
    title: "Pumpkin Pal",
    category: "free",
    difficulty: 1,
    blurb: "The smiliest jack-o'-lantern in the patch",
    art: [
      { d: circlePath(70, 70, 36) },
      { d: circlePath(58, 62, 7), line: true },
      { d: circlePath(84, 80, 5), line: true },
      { d: starPath(140, 48, 9) },
      { d: starPath(340, 62, 11) },
      { d: starPath(372, 152, 7) },
      { d: starPath(30, 152, 8) },
      { d: starPath(300, 130, 6) },
      { d: groundPath(452) },
      { d: ellipsePath(150, 340, 62, 98) },
      { d: ellipsePath(250, 340, 62, 98) },
      { d: ellipsePath(200, 340, 80, 108) },
      { d: "M 192 218 C 188 200 190 186 196 172 C 208 178 214 192 212 210 C 208 218 198 222 192 218 Z" },
      { d: "M 214 214 C 238 196 262 200 270 216 C 258 232 232 236 216 226 Z" },
      { d: "M 152 300 L 184 300 L 168 328 Z" },
      { d: "M 216 300 L 248 300 L 232 328 Z" },
      { d: "M 192 340 L 208 340 L 200 354 Z" },
      { d: "M 148 372 L 170 398 L 186 380 L 200 398 L 214 380 L 230 398 L 252 372 C 250 392 230 408 200 408 C 170 408 150 392 148 372 Z" },
      { d: circlePath(122, 306, 9) },
      { d: circlePath(278, 306, 9) },
    ],
  },
  {
    id: "friendly-ghost",
    title: "Friendly Ghost",
    category: "free",
    difficulty: 1,
    blurb: "A boo-tiful bestie who loves hugs",
    art: [
      { d: circlePath(330, 80, 36) },
      { d: circlePath(320, 72, 6), line: true },
      { d: circlePath(340, 92, 4), line: true },
      { d: starPath(40, 60, 9) },
      { d: starPath(160, 46, 7) },
      { d: starPath(380, 170, 8) },
      { d: starPath(30, 260, 8) },
      { d: groundPath(448) },
      { d: circlePath(95, 155, 15) },
      { d: "M 80 152 C 60 132 48 140 44 158 C 54 152 60 158 58 166 C 66 158 74 162 74 170 Z" },
      { d: "M 110 152 C 130 132 142 140 146 158 C 136 152 130 158 132 166 C 124 158 116 162 116 170 Z" },
      {
        d: "M 135 180 C 135 106 165 90 200 90 C 235 90 265 106 265 180 L 265 355 C 265 380 250 392 236 384 C 224 377 214 384 214 398 C 214 412 200 420 192 410 C 186 402 176 400 168 408 C 156 420 138 414 136 396 L 135 355 Z",
      },
      { d: ellipsePath(178, 205, 13, 17) },
      { d: ellipsePath(222, 205, 13, 17) },
      { d: ellipsePath(200, 248, 15, 20) },
      { d: circlePath(146, 238, 9) },
      { d: circlePath(254, 238, 9) },
      { d: circlePath(300, 318, 13) },
      { d: "M 287 312 L 277 306 M 287 324 L 277 330", line: true },
    ],
  },
  {
    id: "cute-bat",
    title: "Cute Bat",
    category: "free",
    difficulty: 2,
    blurb: "Flap flap hooray, king of the night",
    art: [
      { d: circlePath(200, 185, 125) },
      { d: circlePath(160, 150, 12), line: true },
      { d: circlePath(250, 160, 9), line: true },
      { d: circlePath(180, 245, 8), line: true },
      { d: starPath(40, 60, 9) },
      { d: starPath(360, 70, 10) },
      { d: starPath(60, 400, 8) },
      { d: "M 160 208 L 175 148 L 198 200 Z" },
      { d: "M 240 208 L 225 148 L 202 200 Z" },
      { d: "M 167 196 L 176 166 L 188 194 Z" },
      { d: "M 233 196 L 224 166 L 212 194 Z" },
      { d: circlePath(200, 252, 56) },
      { d: circlePath(183, 242, 9) },
      { d: circlePath(217, 242, 9) },
      { d: "M 184 288 L 189 304 L 194 288 Z" },
      { d: "M 206 288 L 211 304 L 216 288 Z" },
      { d: circlePath(155, 268, 8) },
      { d: circlePath(245, 268, 8) },
      {
        d: "M 158 296 C 112 254 56 266 34 314 C 60 304 78 316 72 334 C 94 322 112 332 108 352 C 128 338 146 346 154 360 Z",
      },
      {
        d: "M 242 296 C 288 254 344 266 366 314 C 340 304 322 316 328 334 C 306 322 288 332 292 352 C 272 338 254 346 246 360 Z",
      },
      { d: ellipsePath(200, 338, 46, 52) },
      { d: circlePath(182, 396, 8) },
      { d: circlePath(218, 396, 8) },
    ],
  },
  {
    id: "haunted-house",
    title: "Haunted House",
    category: "free",
    difficulty: 3,
    blurb: "Spooky outside, cozy inside",
    art: [
      { d: circlePath(75, 70, 34) },
      { d: circlePath(66, 62, 6), line: true },
      { d: starPath(150, 60, 8) },
      { d: starPath(360, 60, 9) },
      { d: starPath(330, 150, 6) },
      { d: groundPath(445) },
      { d: "M 96 250 L 200 152 L 304 250 Z" },
      { d: circlePath(200, 215, 13) },
      { d: "M 118 250 L 282 250 L 282 438 L 118 438 Z" },
      { d: "M 172 438 L 172 366 C 172 344 228 344 228 366 L 228 438 Z" },
      { d: circlePath(216, 404, 4), line: true },
      { d: "M 138 285 L 178 285 L 178 325 L 138 325 Z" },
      { d: "M 158 285 L 158 325 M 138 305 L 178 305", line: true },
      { d: "M 222 285 L 262 285 L 262 325 L 222 325 Z" },
      { d: "M 242 285 L 242 325 M 222 305 L 262 305", line: true },
      { d: "M 282 300 L 336 300 L 336 438 L 282 438 Z" },
      { d: "M 272 304 L 309 226 L 346 304 Z" },
      { d: circlePath(309, 340, 11) },
      { d: "M 40 438 L 40 398 L 52 398 L 52 438 Z" },
      { d: "M 66 438 L 66 398 L 78 398 L 78 438 Z" },
      { d: "M 34 412 L 96 412", line: true },
      {
        d: "M 236 378 C 236 352 264 352 264 378 L 264 410 C 258 418 252 412 246 416 C 240 420 236 416 236 410 Z",
      },
      { d: circlePath(244, 380, 3), line: true },
      { d: circlePath(256, 380, 3), line: true },
    ],
  },
  {
    id: "witchs-cat",
    title: "Witch's Cat",
    category: "free",
    difficulty: 2,
    blurb: "Midnight naps and magic snacks",
    art: [
      { d: circlePath(330, 72, 34) },
      { d: circlePath(322, 64, 6), line: true },
      { d: starPath(50, 70, 9) },
      { d: starPath(120, 50, 7) },
      { d: starPath(40, 200, 8) },
      { d: groundPath(452) },
      { d: "M 162 130 L 200 52 L 238 130 Z" },
      { d: ellipsePath(200, 134, 76, 16) },
      { d: "M 192 104 L 210 104 L 208 118 L 190 118 Z" },
      { d: "M 156 196 L 148 140 L 196 178 Z" },
      { d: "M 244 196 L 252 140 L 204 178 Z" },
      { d: "M 162 186 L 158 158 L 186 178 Z" },
      { d: "M 238 186 L 242 158 L 214 178 Z" },
      { d: circlePath(200, 232, 58) },
      { d: ellipsePath(181, 228, 11, 15) },
      { d: ellipsePath(219, 228, 11, 15) },
      { d: "M 181 220 L 181 236 M 219 220 L 219 236", line: true },
      { d: "M 194 250 L 206 250 L 200 260 Z" },
      { d: "M 148 244 L 118 238 M 148 256 L 120 260 M 252 244 L 282 238 M 252 256 L 280 260", line: true },
      { d: "M 200 260 C 196 268 188 268 184 262 M 200 260 C 204 268 212 268 216 262", line: true },
      {
        d: "M 158 278 C 132 326 126 396 134 424 C 138 442 158 448 200 448 C 242 448 262 442 266 424 C 274 396 268 326 242 278 C 230 258 170 258 158 278 Z",
      },
      { d: ellipsePath(200, 390, 34, 40) },
      { d: "M 168 300 C 176 296 184 296 190 300 M 210 300 C 216 296 224 296 232 300 M 164 330 C 172 326 180 326 186 330 M 214 330 C 220 326 228 326 236 330", line: true },
      {
        d: "M 258 418 C 330 428 356 352 318 318 C 300 302 276 310 282 330 C 286 342 300 344 304 334 C 324 350 306 400 262 394 Z",
      },
      { d: "M 164 282 C 180 296 220 296 236 282", line: true },
      { d: circlePath(200, 300, 10) },
      { d: ellipsePath(172, 440, 18, 10) },
      { d: ellipsePath(228, 440, 18, 10) },
    ],
  },
  {
    id: "trick-or-treat",
    title: "Trick or Treat",
    category: "free",
    difficulty: 2,
    blurb: "A candy haul worth flying for",
    art: [
      { d: starPath(60, 70, 9) },
      { d: starPath(200, 50, 7) },
      { d: starPath(350, 120, 8) },
      { d: heartPath(340, 210, 14) },
      { d: groundPath(455) },
      { d: "M 140 284 L 260 284 L 260 304 L 140 304 Z" },
      { d: "M 142 284 A 58 58 0 0 1 258 284 L 236 284 A 36 36 0 0 0 164 284 Z" },
      { d: "M 150 304 L 250 304 L 266 434 L 134 434 Z" },
      { d: circlePath(200, 368, 26) },
      { d: "M 188 360 L 197 360 L 192 369 Z" },
      { d: "M 203 360 L 212 360 L 207 369 Z" },
      { d: "M 190 379 L 196 373 L 200 379 L 204 373 L 210 379", line: true },
      { d: "M 296 260 L 306 260 L 302 380 L 298 380 Z" },
      { d: circlePath(301, 222, 46) },
      { d: "M 301 222 m 0 -30 a 30 30 0 1 1 -30 30 a 24 24 0 1 0 24 -24 a 16 16 0 1 1 -16 16", line: true },
      { d: "M 84 288 L 110 372 C 96 388 72 388 58 372 Z" },
      { d: "M 64 340 C 76 348 92 348 104 340 M 60 362 C 74 372 94 372 108 362", line: true },
      { d: ellipsePath(112, 180, 30, 22) },
      { d: "M 84 168 L 66 152 L 70 186 Z" },
      { d: "M 84 192 L 66 208 L 70 174 Z" },
      { d: "M 140 168 L 158 152 L 154 186 Z" },
      { d: "M 140 192 L 158 208 L 154 174 Z" },
      { d: "M 90 176 L 134 186", line: true },
    ],
  },
];
